import Layout from '../components/Layout'
import { PageHeader, Section, Card } from '../components/UIComponents'

export default function Store() {
  return (
    <Layout>
      <div className="space-y-8 max-w-6xl mx-auto">
        <PageHeader
          icon="🛍️"
          title="Tienda"
          description="Compra productos y servicios con tus fondos"
        />

        <Section title="Artículos Destacados">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { name: 'Premium Tier', price: '$9.99', icon: '👑' },
              { name: 'Boost 1h', price: '$2.99', icon: '⚡' },
              { name: 'Bundle Pack', price: '$14.99', icon: '📦' },
              { name: 'Exclusive Badge', price: '$4.99', icon: '🏷️' },
            ].map((item, i) => (
              <Card key={i} className="hover:border-purple-500 transition-colors">
                <div className="space-y-3">
                  <div className="text-4xl text-center">{item.icon}</div>
                  <h3 className="text-white font-semibold text-center">{item.name}</h3>
                  <div className="flex items-center justify-between">
                    <span className="text-green-400 font-bold">{item.price}</span>
                    <button className="px-3 py-1 bg-purple-600 hover:bg-purple-700 text-white text-sm font-semibold rounded transition-colors">
                      Comprar
                    </button>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </Section>

        <Section title="Mis Compras">
          <Card>
            <div className="text-center py-8">
              <p className="text-slate-400">Sin compras anteriores</p>
            </div>
          </Card>
        </Section>
      </div>
    </Layout>
  )
}
